import React from "react";

export function FnmHelpLink() {
  return <a href="https://golanis.com/training-tips/"
            target="_blank"
            rel="noopener noreferrer"
            className="fnm-help-link">FNM Help</a>
}
